// extracted by mini-css-extract-plugin
module.exports = {"radio-item":"radio-item_radio-item__0emR3","top":"radio-item_top__CTWbQ","text":"radio-item_text__0PDQw","content":"radio-item_content__pzSkt"};